import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <img src="/images/bg.png" className="App-bg" alt="OneSixteen Canada" />
    </div>
  );
}

export default App;
